/* Additional high level and utilities variables not represented by design tokens */
:root {
  color-scheme: light;
  //interpolate-size: allow-keywords;
  --cbp-app-color-scheme: light; // Is this needed?

  --cbp-color-body-text: var(--cbp-color-text-darkest);
  --cbp-color-body-background: var(--cbp-color-branding-cbp-light);

  // Using clamp is a more modern way of implementing this, but gives a variable size between the min and max points.
  // 20px < 600px ; 32px > 600px ; 44px > 1400px
  //--cbp-responsive-spacing-outer: clamp( var(--cbp-space-5x), 0.179rem + 2.857vw, var(--cbp-space-11x));
  --cbp-responsive-spacing-outer: var(--cbp-space-5x);
  --cbp-responsive-spacing-inner: var(--cbp-responsive-spacing-outer); // temporary - for discussion

  --cbp-responsive-spacing-gap: var(--cbp-space-4x);
}

@media (min-width: $cbp-breakpoint-md) {
  :root {
    --cbp-responsive-spacing-outer: var(--cbp-space-8x);
    --cbp-responsive-spacing-gap: var(--cbp-space-7x);
  }
}

@media (min-width: $cbp-breakpoint-xl) {
  :root {
    --cbp-responsive-spacing-outer: var(--cbp-space-11x);
  }
}

[data-cbp-theme=light] {
  color-scheme: light;
  --cbp-app-color-scheme: light; 
}

[data-cbp-theme=dark] {
  color-scheme: dark;
  --cbp-app-color-scheme: dark;
  --cbp-color-body-text: var(--cbp-color-text-lightest);
  --cbp-color-body-background: var(--cbp-color-branding-cbp-dark);
}


html {
  font-size: 100%;
  //color-scheme: light dark;
}

body {
  color: var(--cbp-color-body-text);
  background-color: var(--cbp-color-body-background);
  font: var(--cbp-font-size-body)/1rem var(--cbp-font-family-roboto);
}

// Give everything a scroll margin so that it's not hidden beneath the sticky app header.
* {
  scroll-margin-block: var(--cbp-space-15x);
}

h1,h2,h3,h4,h5,h6 {
  line-height: normal;
}

p,
blockquote {
  margin-bottom: var(--cbp-space-4x);
}

// TODO: Should this include blockquote and list items?
p {
  line-height: 1.25rem;
}

mark,
::highlight {
  color: var(--cbp-color-text-darkest);
  background-color: var(--cbp-color-highlight);
}

hr {
  border: none;
  height: 1px;
  background-color: var(--cbp-color-body-text);
}

a[href],
button {
  cursor: pointer;
}

[aria-disabled=true],
:disabled,
input:read-only:not([type=checkbox], [type=radio], [type=file], [type=range], [type=color]),
textarea:read-only {
  cursor: not-allowed;
}

/* Ensure that `hidden` is not overridden by other selectors setting display, such as flex or grid */
[hidden] {
  display: none !important;
}

/* Expose a generic class for visually hiding content in an accessible manner */
.cbp-visually-hidden {
  @include visuallyHidden
}